<template>
<div class="content">
  <div>
    <b-tabs content-class="mt-3">
      <b-tab title="Uživatelé" active>
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col">
              <general-datatables :tableId="'userTable'" v-if="tableUserData" :columns="tableUserColumns" :data="tableUserData" 
              tableCaption="Uživatelé" tableDescription="Seznam všech uživatelů" formPath="/usersForm" :getDataFunction="getUserTableData"
              :tableType="$TablesEnum.user" :canCreate="canCreateUser" :canDelete="canDeleteUser"></general-datatables>
            </div>
          </div>
        </div>      
      </b-tab>
      <b-tab title="Role">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col">
              <general-datatables :tableId="'userRoleTable'" v-if="tableUserRoleData" :columns="tableUserRoleColumns" :data="tableUserRoleData" 
              tableCaption="Role" tableDescription="Seznam všech rolí" formPath="/userRolesForm" :getDataFunction="getUserRoleTableData"
              :tableType="$TablesEnum.userRole"></general-datatables>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="Oprávnění">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col">
              <general-datatables :tableId="'userPermissionTable'" v-if="tableUserPermissionData" :columns="tableUserPermissionColumns" :data="tableUserPermissionData" 
              tableCaption="Uživatelská oprávnění" tableDescription="Seznam všech uživatelských oprávnění" formPath="/userPermissionsForm" :getDataFunction="getUserPermissionTableData"
              :tableType="$TablesEnum.userPermission" :canCreate="canCreateUser" :canDelete="canDeleteUser" :userPermissionTable="true"></general-datatables>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</div>
</template>

<script type="text/javascript" charset="utf8" src="@/js/dataTableUtils.js"></script>
<script>
  import dataService from '@/services/dataService.js';
  import GeneralDatatables from '@/components/GeneralDatatables.vue';
  import vueFormHelper from '@/js/VueFormHelper.js';

  const tableUserColumns = [
    {name: 'Id', caption: 'Id'},
    {name: 'UserUserRoles', caption: 'Role', isList: true, listColumn: ['UserRole', 'Name']},
    {name: 'UserName', caption: 'Uživatelské jméno'},
    {name: 'Name', caption: 'Jméno'},
    {name: 'Surname', caption: 'Příjmení'},
    {name: 'Email', caption: 'Email'},
    {name: 'PhoneNumber', caption: 'Telefonní číslo'},
    {name: 'Active', caption: 'Aktivní', checkbox: true}
  ];

  const tableUserRoleColumns = [
    {name: 'Id', caption: 'Id', width: '10%'},
    {name: 'Name', caption: 'Název', width: '100%'}
  ];

  const tableUserPermissionColumns = [
    {name: 'Id', caption: 'Id', width: '10%'},
    {name: 'Name', caption: 'Název', width: '100%'}
  ];

  export default {
    components: {
      GeneralDatatables
    },
    asyncComputed: {
      tableUserData: async () => {
        return JSON.parse(await dataService.getAllUsers());
      },
      tableUserRoleData: async () => {
        return JSON.parse(await dataService.getAllUserRoles());
      },
      tableUserPermissionData: async () => {
        return JSON.parse(await dataService.getAllUserPermissions());
      },
    },
    methods: {
      async getUserTableData() {
        return JSON.parse(await dataService.getAllUsers());
      },
      async getUserRoleTableData() {
        return JSON.parse(await dataService.getAllUserRoles());
      },
      async getUserPermissionTableData() {
        return JSON.parse(await dataService.getAllUserPermissions());
      }
    },
    data () {
      return {
        tableUserColumns: [...tableUserColumns],
        tableUserRoleColumns: [...tableUserRoleColumns],
        tableUserPermissionColumns: [...tableUserPermissionColumns],
        canCreateUser: vueFormHelper.userHasPermission(this, 13),
        canDeleteUser: vueFormHelper.userHasPermission(this, 15)
      }
    }
  }
</script>